<span [ngClass]="['counter', type]">
    <span class="prefix">{{prefixText}}</span>
    <span class="timer">{{timerText}}</span>
</span>